<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Status</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="sampleStatusCodes" :showDesc="false" v-model="status_code" />
				</span>

				<em class="lt_text">Entry Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="entry_date_from"/> ~ <CustomDatePicker v-model="entry_date_to"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<!-- <span class="int_type sm_int">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span> -->

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="6%">Sample No</th>
					<th width="8%">Status</th>
					<th width="6%">Entry Date</th>
					<th width="8%">Entry User</th>
					<th width="6%">Request Date</th>
					<th width="6%">Ready Date</th>
					<th width="6%">Pick Up Date</th>
					<th width="8%">Pick Up User</th>
					<!-- <th width="6%">Return Date</th> -->
					<th width="10%">Print Date Time</th>
					<th width="10%">Sales Group</th>
					<th width="4%">Req. Qty.</th>
					<th width="4%">Pick Qty.</th>
					<th>Description</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="sample in samples" v-bind:key="sample.sample_no">
					<td class="al_left">
						<a href="javascript:;" @click="selectSample(sample)">{{ sample.sample_dn }}</a>
					</td>
					<td class="al_center">{{ sample.status_code | sampleStatusName }}</td>
					<td class="al_left">{{ sample.entry_date }}</td>
					<td class="al_left">{{ sample.crt_name }}</td>
					<td class="al_left">{{ sample.request_date }}</td>
					<td class="al_left">{{ sample.ready_date }}</td>
					<td class="al_left">{{ sample.pickup_date }}</td>
					<td class="al_left">{{ sample.pickup_user }}</td>
					<!-- <td class="al_left">{{ sample.return_date }}</td> -->
					<td class="al_left">{{ sample.print_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
					<td class="al_left">{{ sample.sales_group_name }}</td>
					<td class="al_right">{{ sample.total_request_quantity | commaSeparated }}</td>
					<td class="al_right">{{ sample.total_pick_quantity | commaSeparated }}</td>
					<td class="al_left">{{ sample.description }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li v-if="modifiable"><router-link :to="{ name: 'sampleDetail', params: { mode: 'add' }, query: { backUri: this.uri } }" class="mgr_15">Add</router-link></li>
				<li v-if="menuAccessible('/sales/sample/inout')"><router-link :to="{ name: 'sampleInout', query: { backUri: this.uri } }">Out / In</router-link></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectSampleList } from '@/api/sales/sample.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
//import PartnerSelect from '@/components/common/PartnerSelect';
//import Modal from '@/components/common/Modal';
import { today, daysAgo } from '@/utils/date.js';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			status_code: null,
			entry_date_from: daysAgo(3),
			entry_date_to: today(),
			sales_group_code: null,
			sampleStatusCodes: [],

			keyword: null,

			salesGroups: [],

			samples: [],

			modalName: '',
			showModal: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
	},
	methods: {
		menuAccessible(menuPath) {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if (menus[i].path == menuPath && menus[i].view_yn == 'Y') return true;
			}
			return false;
		},
		selectSample(sample) {
			this.$router.push({ name: 'sampleDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sample_no: sample.sample_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectSamples(pageNo);
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			//this.invoice_type = 'S';
			this.status_code = null;
			this.entry_date_from = daysAgo(3);
			this.entry_date_to = today();
			this.sales_group_code = null;
			this.keyword = null;

			//this.search();

			//this.selectInvoices();
			// this.dept_code = null;
		},
		async search() {
			await this.selectSamples();
			//if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectSamples(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			const { data } = await apiSelectSampleList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				status_code: this.status_code,
				entry_date_from: this.entry_date_from,
				entry_date_to: this.entry_date_to,
				sales_group_code: this.sales_group_code,
				//keyword: this.keyword,
			});

			//console.log(data);
			this.samples = data.sampleList;
			this.list_count = data.list_count; //data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/sample?page_no=' + this.page_no;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.status_code) uri += '&status_code=' + this.status_code;
			if (this.entry_date_from) uri += '&entry_date_from=' + this.entry_date_from;
			if (this.entry_date_to) uri += '&entry_date_to=' + this.entry_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			//////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			await this.index();
			this.sampleStatusCodes = this.$sampleStatusCodes;

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			if (this.$route.query.entry_date_from) this.entry_date_from = this.$route.query.entry_date_from;
			if (this.$route.query.entry_date_to) this.entry_date_to = this.$route.query.entry_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;

			await this.selectSamples(this.$route.query.page_no);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_sample');
		this.$store.commit('setSubTitle', 'Sales -> Sample');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
